// extracted by mini-css-extract-plugin
export default {"CreateIssueDialogContainer":"CreateIssueDialog-module__CreateIssueDialogContainer__WMiQFFQ"};